import { lazy } from "react";
import GalleryIndex from "../templates/image_gallery/Index";

export const getAppIndexComponent = (appKey: string) => {
  if (appKey === undefined) {
    return null;
  }

  if (appKey === "image_gallery") {
    return GalleryIndex;
  }

  try {
    const indexes = lazy(() => import(`../templates/${appKey}/Index`));
    return indexes;
  } catch (error) {
    console.error("Error loading component:", error);
    return null;
  }
};
